"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectionAbilityHandler = exports.RedirectionActorAbilityFactory = exports.RedirectionAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const Taunted_1 = require("../../core/effects/core/Taunted");
const ts_essentials_1 = require("ts-essentials");
class RedirectionAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Redirection;
        this.__typeName = "Redirection";
    }
}
exports.RedirectionAbilityArgs = RedirectionAbilityArgs;
let RedirectionActorAbilityFactory = class RedirectionActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Redirection", "AllCompanions", 3);
    }
};
RedirectionActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Redirection")
], RedirectionActorAbilityFactory);
exports.RedirectionActorAbilityFactory = RedirectionActorAbilityFactory;
let RedirectionAbilityHandler = class RedirectionAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const companions = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllCompanions);
        (0, ts_essentials_1.assert)(companions.length > 0, "REDIRECT_REQUIRES_A_LIVING_COMPANION");
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                    .forEach(targetId => container.applyDebuff({
                    sequence,
                    attackerId: (0, __1.randomElement)(companions),
                    targetId,
                    duration: Duration_1.Duration.Turns(1),
                    effect: new Taunted_1.TauntedEffectArgs()
                }));
            },
        });
    }
};
RedirectionAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Redirection)
], RedirectionAbilityHandler);
exports.RedirectionAbilityHandler = RedirectionAbilityHandler;
